import { Link } from 'react-router-dom';
import { Info } from 'lucide-react';

// Legacy staff pages are read-only: the client file's Income Tax / BAS tabs are the working screens. Data is kept.
export const LegacyBanner = ({ module }) => (
  <div className="flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900" data-testid="legacy-readonly-banner">
    <Info className="h-4 w-4" />
    This page is read-only. Work on {module} now happens in each client's <b>{module}</b> tab (Clients → client → {module}).
    <Link to="/clients" className="ml-auto underline">Go to Clients</Link>
  </div>
);
